/**
 * Get metadata for an image (width, height) by loading it in the background
 * @param url URL of the image to load
 * @returns Promise resolving to image metadata object with width and height
 */
export const getMeta = (
  url: string
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.width, height: img.height });
    img.onerror = error => reject(error);
    img.src = url;
  });
};

/**
 * Case-insensitive includes check for strings
 * @param text The string to search within
 * @param searchString The substring to search for
 * @returns Boolean indicating if searchString exists in text (case-insensitive)
 */
export const includesIgnoreCase = (
  text: string,
  searchString: string
): boolean => {
  if (!text || !searchString) return false;
  return text.toLowerCase().includes(searchString.toLowerCase());
};

